import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetExItemsAllSuspense } from '@/context/services/ex_item/ExItem.service';
import { ExItem } from 'ap-openapi';

export const useFindExItems = () => {
  const items = useGetExItemsAllSuspense();
  const findById = useFindById<ExItem, 'id', 'name'>(items, {
    key: 'id',
    return: 'name',
    defaultVal: '',
  });
  const findByName = useFindByName<ExItem, 'name', 'id'>(items, {
    key: 'name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findExItemsById: findById,
    findExItemsByName: findByName,
  };
};
